var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.255 1.13a.833.833 0 0 1 0 1.178l-4.411 4.41 4.41 4.411a.833.833 0 1 1-1.178 1.179l-5-5a.833.833 0 0 1 0-1.179l5-5a.833.833 0 0 1 1.179 0",
    clipRule: "evenodd"
  })));
};
export default SvgBackIcon;